import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/010-upload.png';
const _withScopeId = n => (_pushScopeId("data-v-1da76126"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page-url"
};
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = {
  class: "mb-2 flex items-center text-sm flex1"
};
const _hoisted_4 = {
  class: "span-radio"
};
const _hoisted_5 = {
  class: "span-radio"
};
const _hoisted_6 = {
  class: "span-radio"
};
const _hoisted_7 = {
  key: 0,
  class: "btn-clear-download flex2"
};
const _hoisted_8 = {
  class: "flex url-container"
};
const _hoisted_9 = {
  class: "btn-set-code"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "get-image"
};
const _hoisted_12 = {
  class: "mb-2 flex items-center text-sm rong-cuo"
};
const _hoisted_13 = {
  class: "upload-logo-div"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload-icon",
  src: _imports_0
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode("将Logo拖拽至此，或 "), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1));
const _hoisted_16 = {
  key: 0,
  class: "logo-span-img"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "mb-2 flex items-center text-sm rong-cuo"
};
const _hoisted_19 = {
  style: {
    "padding-left": "50px",
    "padding-top": "20px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_color_picker = _resolveComponent("el-color-picker");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_drawer = _resolveComponent("el-drawer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_withDirectives(_createElementVNode("input", {
    type: "radio",
    name: "type",
    value: "1",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.radioA = $event)
  }, null, 512), [[_vModelRadio, $data.radioA]]), _createTextVNode(" 文字生成二维码 ")]), _createElementVNode("span", _hoisted_5, [_withDirectives(_createElementVNode("input", {
    type: "radio",
    name: "type",
    value: "2",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.radioA = $event),
    disabled: ""
  }, null, 512), [[_vModelRadio, $data.radioA]]), _createTextVNode(" 文件生成二维码 ")]), _createElementVNode("span", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    type: "radio",
    name: "type",
    value: "2",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.radioA = $event),
    disabled: ""
  }, null, 512), [[_vModelRadio, $data.radioA]]), _createTextVNode(" 音/视频生成二维码 ")])]), $data.showImg ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_button, {
    ref: "qrcode",
    onClick: $options.setCode,
    size: "small"
  }, {
    default: _withCtx(() => [_createTextVNode("设置二维码")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    onClick: $options.clearFn,
    size: "small"
  }, {
    default: _withCtx(() => [_createTextVNode("清除")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    onClick: $options.downloadAll,
    disabled: $data.disabledBtn
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.downloadTxt), 1)]),
    _: 1
  }, 8, ["onClick", "disabled"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, {
    ref: "textarea",
    class: "url-textarea",
    modelValue: $data.text,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.text = $event),
    type: "textarea",
    placeholder: $data.placeholder
  }, null, 8, ["modelValue", "placeholder"]), _createElementVNode("div", {
    class: "url-form",
    style: _normalizeStyle({
      width: $data.form.width + 'px',
      height: $data.form.width + 'px'
    })
  }, [_createElementVNode("div", _hoisted_9, [!$data.showImg ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    ref: "qrcode",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.setCode && $options.setCode(...args))
  }, " 设置二维码 ", 512)) : _createCommentVNode("", true)]), $data.showImg ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "url-form-uu",
    style: _normalizeStyle({
      width: $data.form.width + 'px',
      height: $data.form.width + 'px'
    })
  }, [$data.showImg ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    ref: "image",
    class: "url-img",
    src: $data.imageSrc
  }, null, 8, _hoisted_10)) : _createCommentVNode("", true)], 4)) : _createCommentVNode("", true)], 4)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.onInputBlur,
    disabled: $data.disabledBtn
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnGet), 1)]),
    _: 1
  }, 8, ["onClick", "disabled"])]), _createVNode(_component_el_drawer, {
    modelValue: $data.drawer,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.drawer = $event),
    title: "设置二维码属性",
    modal: false,
    direction: 'ltr',
    "with-header": false,
    size: '35%'
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form, {
      model: $data.form,
      "label-width": "auto",
      style: {
        "max-width": "600px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "二维码内容："
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          ref: "textarea",
          style: {
            "height": "80px"
          },
          class: "url-textarea",
          modelValue: $data.text,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.text = $event),
          type: "textarea",
          placeholder: $data.placeholder
        }, null, 8, ["modelValue", "placeholder"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "宽度："
      }, {
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: $data.form.width,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.width = $event),
          class: "slider-width",
          "show-input": "",
          size: "small",
          "show-stops": "",
          step: 5,
          min: 10,
          max: "2000"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "容错率："
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", {
          onClick: _cache[7] || (_cache[7] = $event => $options.setRCFn('H')),
          class: _normalizeClass({
            'active': $data.form.errorCorrectionLevel === 'H'
          })
        }, " 最高 ", 2), _createElementVNode("span", {
          onClick: _cache[8] || (_cache[8] = $event => $options.setRCFn('Q')),
          class: _normalizeClass({
            'active': $data.form.errorCorrectionLevel === 'Q'
          })
        }, " 高 ", 2), _createElementVNode("span", {
          onClick: _cache[9] || (_cache[9] = $event => $options.setRCFn('M')),
          class: _normalizeClass({
            'active': $data.form.errorCorrectionLevel === 'M'
          })
        }, " 中 ", 2), _createElementVNode("span", {
          onClick: _cache[10] || (_cache[10] = $event => $options.setRCFn('L')),
          class: _normalizeClass({
            'active': $data.form.errorCorrectionLevel === 'L'
          })
        }, " 低 ", 2)])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "质量："
      }, {
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: $data.form.quality,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.form.quality = $event),
          class: "slider-width",
          "show-input": "",
          size: "small",
          "show-stops": "",
          step: 0.1,
          min: 0.1,
          max: "100"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "边距："
      }, {
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: $data.form.margin,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.form.margin = $event),
          class: "slider-width",
          "show-input": "",
          size: "small",
          "show-stops": "",
          step: 1,
          min: 1,
          max: $data.form.width / 2
        }, null, 8, ["modelValue", "max"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "码色："
      }, {
        default: _withCtx(() => [_createVNode(_component_el_color_picker, {
          modelValue: $data.form.color.dark,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.form.color.dark = $event),
          size: "large"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "背景色："
      }, {
        default: _withCtx(() => [_createVNode(_component_el_color_picker, {
          modelValue: $data.form.color.light,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.form.color.light = $event),
          size: "large"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "上传logo："
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_upload, {
          class: "upload",
          drag: "",
          action: "#",
          accept: $data.acceptImageFormats,
          "show-file-list": false,
          data: $options.uploadOptions,
          "on-change": $options.onChange
        }, {
          default: _withCtx(() => [_hoisted_14, _hoisted_15]),
          _: 1
        }, 8, ["accept", "data", "on-change"]), $data.fileList.length > 0 && $data.fileList[0].response && $data.fileList[0].response.data && $data.fileList[0].response.data.images ? (_openBlock(), _createElementBlock("span", _hoisted_16, [_createElementVNode("img", {
          src: $data.fileList[0].response.data.images[0]
        }, null, 8, _hoisted_17)])) : _createCommentVNode("", true)])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "设置logo位置："
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", {
          onClick: _cache[15] || (_cache[15] = $event => $options.setLogoRCFn('M')),
          class: _normalizeClass({
            'active': $data.logoPosition === 'M'
          })
        }, " 中间 ", 2), _createElementVNode("span", {
          onClick: _cache[16] || (_cache[16] = $event => $options.setLogoRCFn('RB')),
          class: _normalizeClass({
            'active': $data.logoPosition === 'RB'
          })
        }, " 右下角 ", 2)])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "设置logo大小："
      }, {
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: $data.logoSizeBg,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.logoSizeBg = $event),
          class: "slider-width",
          "show-input": "",
          size: "small",
          "show-stops": "",
          step: 0.05,
          min: 0.05,
          max: "1"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "设置logo阴影："
      }, {
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: $data.logoSizeBgBlur,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.logoSizeBgBlur = $event),
          class: "slider-width",
          "show-input": "",
          size: "small",
          "show-stops": "",
          step: 1,
          min: 1,
          max: "20"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.downloadAll,
          disabled: $data.disabledBtn
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($data.downloadTxt), 1)]),
          _: 1
        }, 8, ["onClick", "disabled"]), _createVNode(_component_el_button, {
          onClick: _cache[19] || (_cache[19] = $event => $data.drawer = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])])]),
    _: 1
  }, 8, ["modelValue"])]);
}